import { Box, Typography, useTheme } from '@mui/material';
import { Trans } from 'react-i18next';

import { getAssetPath } from '@/constants/configs';

import { AddressForm } from '@/pages/onboarding/address-information/components/AddressForm/AddressForm';

import { Tenant } from '@/types/common';

import { getDataTestId } from '@/utils/browser';
import { isCaymanTenant } from '@/utils/tenant';

import { AddressCountryBranding } from './AddressBody.styled';

type Props = {
  tenant?: Tenant;
  hasLogo?: boolean;
  onFinished: () => void;
};

const AddressBody = ({ hasLogo, tenant, onFinished }: Props) => {
  const theme = useTheme();

  const handleFinished = () => {
    onFinished();
  };

  const getCountryBranding = () => {
    if (isCaymanTenant(tenant)) {
      return (
        <AddressCountryBranding
          src={getAssetPath('/cayman-logo-with-text.svg')}
        />
      );
    }

    return <AddressCountryBranding src={getAssetPath('/logo-with-text.svg')} />;
  };

  return (
    <>
      {hasLogo && (
        <Box display="flex" justifyContent="center" mt={3} mb={3}>
          {getCountryBranding()}
        </Box>
      )}

      <Typography
        variant="body2"
        textAlign="center"
        color={theme.palette.neutral[800]}
        mb={6}
        {...getDataTestId('address-form')}
      >
        <Trans
          i18nKey="createNewAccount.addressPage.body"
          components={{
            bold: <strong />,
          }}
        />
      </Typography>
      <AddressForm onFinished={handleFinished} />
    </>
  );
};

export default AddressBody;
